document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('[data-wa-float]');
  if (!el) return;

  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var showOnDesktop = el.dataset.showDesktop === 'true';
  var showOnMobile = el.dataset.showMobile === 'true';

  var shouldShow = isMobile ? showOnMobile : showOnDesktop;
  if (!shouldShow) return;

  var delay = (parseFloat(el.dataset.showDelay) || 0) * 1000;

  setTimeout(function () {
    el.classList.add('is-visible');
  }, delay);
});
